import { createSlice } from "@reduxjs/toolkit";

const initialState = {

}

const customerDataSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        addCustomer: (state, action) => {
            state.data = action.payload
        },
        addAddress: (state, action) => {
            state.data = action.payload
        }
    }
})

export const { addCustomer, addAddress } = customerDataSlice.actions
export default customerDataSlice.reducer